import {
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { Observable, takeUntil } from "rxjs";
import { Area } from "src/app/shared/model/tickets/area.model";
import { Formulario } from "src/app/shared/model/tickets/formulario";
import { Tickets } from "src/app/shared/model/tickets/tickets.model";
import { SweetAlertComponent } from "src/app/shared/SweetMesssage";
import { TicketsService } from "../../tickets.service";
import { ConsultaList } from "src/app/shared/model/core/ConsultaList.model";
import { TicketTipo } from "src/app/utilerias/enums/ticket-tipo.enum";
import { DetallePerfilTicketsComponent } from "../../solicitud/perfil-tickets/detalle-perfil-tickets/detalle-perfil-tickets.component";
import { NgClass, NgFor, NgIf, NgStyle } from "@angular/common";
import { MatTooltip } from "@angular/material/tooltip";
import { MatIcon } from "@angular/material/icon";
import { ColumnaTicketsBaseComponent } from "../../tickets-comun/columna-tickets-base.component";

@Component({
  selector: "app-notificacion-ticket",
  standalone: true,
  templateUrl: "./notificacion-ticket.component.html",
  styleUrls: ["./notificacion-ticket.component.css"],
  imports: [MatIcon, MatTooltip, NgClass, NgFor, NgIf, NgStyle],
})
export class NotificacionTicketComponent extends ColumnaTicketsBaseComponent {
  @Input() formulario: Formulario;
  @Input() ticket: Tickets;
  @Output() mostrarDetalle = new EventEmitter<Formulario>();
  @Output() asignarTicket = new EventEmitter<Tickets>();

  constructor(
    mensaje: SweetAlertComponent,
    public dialog: MatDialog,
    service: TicketsService,
    router: Router
  ) {
    super(mensaje, service, router);
  }

  solicitudSeleccionada(elemento: Tickets): void {
    this.tickets = elemento;
    this.formulario.mostrarFrmControl = false;
    this.formulario.mostrarFrmDetalle = true;
    this.ticket.id_ticket = this.tickets.id_ticket;
    this.ticket.asunto = this.tickets.asunto;
    this.ticket.id_estatus = this.tickets.id_estatus;

    if (elemento.actualizado) {
      this.actualizarBanderaTicket();
    }

    this.mostrarDetalle.emit(this.formulario);
    this.asignarTicket.emit(this.ticket);
  }

  llamado(): void {
    const hasPagination = Number.isFinite(this.regXPagina) && this.regXPagina > 0;

    if (hasPagination) {
      this.tickets = new Tickets();
      this.tickets.id_estatus = this.estatusSolicitud;
      this.tickets.id_ticket = this.numero && this.numero > 0 ? this.numero : null;
      this.tickets.asunto = this.nombreCorto;
      this.tickets.fechaSolicitud = this.fechaSeleccionada ? new Date(this.fechaSeleccionada) : null;
      this.tickets.id_area = this.areaSeleccionada ? this.areaSeleccionada.id : null;
      this.cargarSolicitudesFiltradas(this.tickets);
      return;
    }

    if (
      (this.nombreCorto && this.nombreCorto.trim()) ||
      this.fechaSeleccionada ||
      this.areaSeleccionada ||
      (this.numero && this.numero > 0)
    ) {
      this.tickets = new Tickets();
      this.tickets.id_estatus = this.estatusSolicitud;
      this.tickets.id_ticket = this.numero && this.numero > 0 ? this.numero : null;
      this.tickets.asunto = this.nombreCorto;
      this.tickets.fechaSolicitud = this.fechaSeleccionada ? new Date(this.fechaSeleccionada) : null;
      this.tickets.id_area = this.areaSeleccionada ? this.areaSeleccionada.id : null;
      this.cargarSolicitudesFiltradas(this.tickets);
      return;
    }

    this.cargarSolicitudesPorEstatus();
  }

  inicializarValores(nom: string, date: Date | string | null, area: Area | null, numero: number | null): void {
    this.nombreCorto = nom;
    this.fechaSeleccionada = date;
    this.areaSeleccionada = area;
    this.numero = numero;
  }

  private actualizarBanderaTicket(): void {
    this.service
      .cambiarBanderaTicket({ id_ticket: this.tickets.id_ticket })
      .pipe(takeUntil(this.destroy$))
      .subscribe();
  }

  protected consultarPorEstatus(ticket: Tickets): Observable<any> {
    return this.service.obtenerTicketsPorEstatus(ticket);
  }

  protected consultarFiltrados(consulta: ConsultaList<Tickets>): Observable<any> {
    return this.service.obtenerTicketsFiltro(consulta);
  }

  mostrarDetalleTicket(datos: Tickets): void {
    const tipo = String(datos.tipoSolicitud ?? "").toUpperCase();
    switch (tipo) {
      case TicketTipo.PERFIL:
        this.mostrarDetallePerfil(datos);
        break;
      case TicketTipo.CAPACITACION:
        this.mostrarDetalleGral(datos);
        break;
      default:
        this.mostrarDetalleGral(datos);
        break;
    }
  }

  mostrarDetalleGral(datosIn: Tickets): void {
    this.router.navigate(["/TICKETS/DetalleTickets", datosIn.id_ticket], {
      state: {
        ticket: datosIn,
        returnUrl: "/TICKETS/Admin",
      },
    });
  }

  mostrarDetallePerfil(datosIn: Tickets): void {
    datosIn.esResolutor = true;
    this.dialog.open(DetallePerfilTicketsComponent, {
      width: "80%",
      panelClass: "custom-modalbox",
      data: { ticket: datosIn },
    });
  }
}
